// @ts-ignore: autogenerated import
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PrivacyEmbedConsentServiceQueryVariables = Exact<{
	service: string;
}>;

export type PrivacyEmbedConsentServiceQuery = {
	embedService: { __typename: 'EmbedService'; rowId: string; privacyText: string | null; cmpServiceId: string | null } | null;
};

export const PrivacyEmbedConsentServiceDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'PrivacyEmbedConsentService' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'service' } },
					type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						alias: { kind: 'Name', value: 'embedService' },
						name: { kind: 'Name', value: 'embedServiceByRowId' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'rowId' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'service' } },
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'rowId' } },
								{ kind: 'Field', alias: { kind: 'Name', value: 'privacyText' }, name: { kind: 'Name', value: 'privacyTextLong' } },
								{ kind: 'Field', alias: { kind: 'Name', value: 'cmpServiceId' }, name: { kind: 'Name', value: 'cmpServiceId' } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<PrivacyEmbedConsentServiceQuery, PrivacyEmbedConsentServiceQueryVariables>;
